import dayjs from "dayjs";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import { pdf } from "@react-pdf/renderer";
import React, { Component } from "react";
import { compose, graphql } from "react-apollo";
import SweetAlert from "react-bootstrap-sweetalert";
import DatePicker from "react-date-picker";
import InputMask from "react-input-mask";
import { PricingDetail, PricingSlot, PricingTable } from "react-pricing-table";
import { withRouter } from "react-router-dom";
import S3FileUpload from "react-s3";
import Select from "react-select";
import {
  setDefaultLanguage,
  setLanguage,
  setTranslations,
  t,
  translate,
} from "react-switch-lang";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { v4 } from "uuid";
import validator from "validator";
import MedCert_Logo from "../../assets/img/med-cert-logo.png";
import PDFGen from "../../components/PDFGenerator";
import { en, es } from "../../locale";
import SubmitOrder from "../../mutations/SubmitOrder";
import parseBool from "../../utils/parseBool.js";
import getAge from "../../utils/getAge";

setTranslations({ en, es });
const langFromLS = localStorage.getItem("locale");
const lang = langFromLS ? langFromLS : navigator.language.substring(0, 2);
setDefaultLanguage(lang);
localStorage.setItem("locale", lang);

class Order extends Component {
  state = {
    name: "",
    lname: "",
    email: "",
    emailVer: "",
    phone: "",
    pfname: "",
    pfname2: "",
    plname: "",
    plname2: "",
    pemail: "",
    pphone: "",
    dob: "",
    paddress: "",
    symptoms: "",
    exposed: null,
    vaccinated: null,
    vaccine: null,
    testType: "",
    reason: "",
    plan: "",
    lab: "",
    type: "",
    confident: false,
    currentStep: 1,
    alert: false,
    clickOnPay: false,
  };

  renderOrders() {
    return (
      <Card className="w-100">
        <CardBody>
          <PricingTable highlightColor="#1976D2">
            <PricingSlot
              onClick={() => this.setState({ type: "COVID", currentStep: 2 })}
              buttonText={t("pricing.buttonText.select")}
              title="COVID-19"
              priceText="$5"
              highlighted
            >
              <PricingDetail>
                <p>- {t("pricing.covid.details.antigen")}</p>
                <p>- PCR (molecular)</p>
              </PricingDetail>
            </PricingSlot>
            <PricingSlot
              onClick={() =>
                this.setState({ type: "INFLUENZA", currentStep: 2 })
              }
              buttonText={t("pricing.buttonText.select")}
              title="INFLUENZA"
              priceText="$5"
            />
            <PricingSlot
              onClick={() =>
                this.setState({ type: "MYCOPLASMA", currentStep: 2 })
              }
              buttonText={t("pricing.buttonText.select")}
              title="MYCOPLASMA"
              priceText="$5"
            />
            <PricingSlot
              onClick={() =>
                this.setState({ type: "PREGNANCY", currentStep: 2 })
              }
              buttonText={t("pricing.buttonText.select")}
              title={t("pricing.pregnancy.title")}
              priceText="$10"
            />
          </PricingTable>
          <h3 className="text-center">{t("pricing.subtitle")}</h3>
          <PricingTable highlightColor="#1976D2">
            <PricingSlot
              onClick={() => this.setState({ type: "VDRL", currentStep: 2 })}
              buttonText={t("pricing.buttonText.select")}
              title={t("pricing.vdrl.title")}
              priceText="$10"
            />
            <PricingSlot
              onClick={() => this.setState({ type: "PPD", currentStep: 2 })}
              buttonText={t("pricing.buttonText.select")}
              title={t("pricing.ppd.title")}
              priceText="$10"
            />
            <PricingSlot
              onClick={() => this.setState({ type: "CXR", currentStep: 2 })}
              buttonText={t("pricing.buttonText.select")}
              title={t("pricing.cxr.title")}
              priceText="$10"
            />
          </PricingTable>
        </CardBody>
      </Card>
    );
  }

  validateUserInfo() {
    if (
      this.state.name &&
      this.state.lname &&
      this.state.phone &&
      this.state.phone.trim().length === 14 &&
      this.state.email &&
      validator.isEmail(this.state.email) &&
      this.state.emailVer &&
      validator.isEmail(this.state.emailVer) &&
      this.state.email === this.state.emailVer
    ) {
      this.setState({ currentStep: 3 });
    } else {
      this.setState({
        alert: (
          <SweetAlert
            warning
            title="Uh-Oh!"
            onConfirm={() => this.setState({ alert: null })}
            closeOnClickOutside={true}
          >
            {t("required")}
          </SweetAlert>
        ),
      });
    }
  }

  renderUserInfo() {
    return (
      <Card className="w-100">
        <CardBody className="text-center">
          <Row>
            <Col lg="6">
              <Typography variant="overline">
                {t("info.form.name")} *
              </Typography>
              <FormGroup className="w-100 d-flex flex-row">
                <Input
                  placeholder={t("info.form.name")}
                  type="text"
                  className="formControlFix"
                  name="name"
                  id="name"
                  value={this.state.name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </FormGroup>

              <Typography variant="overline">
                {t("info.form.last")} *
              </Typography>
              <FormGroup className="w-100 d-flex flex-row">
                <Input
                  placeholder={t("info.form.last")}
                  type="text"
                  className="formControlFix"
                  name="lname"
                  id="lname"
                  value={this.state.lname}
                  onChange={(e) => this.setState({ lname: e.target.value })}
                />
              </FormGroup>
            </Col>
            <Col lg="6">
              <Typography variant="overline">
                {t("info.form.phone")} *
              </Typography>
              <FormGroup className="w-100 d-flex flex-row">
                <Input
                  placeholder={t("info.form.phone")}
                  type="tel"
                  className="formControlFix"
                  name="phone"
                  maskChar=" "
                  mask={"(999) 999-9999"}
                  id="phone"
                  value={this.state.phone}
                  tag={InputMask}
                  onChange={(e) => this.setState({ phone: e.target.value })}
                />
              </FormGroup>

              <Typography variant="overline">Email *</Typography>
              <FormGroup className="w-100 d-flex flex-row">
                <Input
                  placeholder="Email"
                  type="text"
                  className="formControlFix"
                  name="email"
                  id="email"
                  value={this.state.email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                />
              </FormGroup>
              <Typography variant="overline">Verify Email *</Typography>
              <FormGroup className="w-100 d-flex flex-row">
                <Input
                  placeholder="Email"
                  type="text"
                  className="formControlFix"
                  name="email"
                  id="email"
                  value={this.state.emailVer}
                  onChange={(e) => this.setState({ emailVer: e.target.value })}
                />
              </FormGroup>
            </Col>

            <Col lg="2">
              <Button color="primary" onClick={() => this.validateUserInfo()}>
                {t("button.next")}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }

  renderConfidential() {
    return (
      <Card className="w-100">
        <CardBody>
          <Row>
            <Col lg="12">
              <p className="justify-content-center">{t("coal.message")}</p>
              <Checkbox
                arial-label={t("coal.checkbox")}
                onChange={(e) =>
                  this.setState({
                    confident: e.target.checked,
                    currentStep: e.target.checked ? 4 : 3,
                  })
                }
                value={this.state.confident}
              />
              {t("coal.checkbox")}
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }

  validatePatientInfo() {
    if (
      this.state.pfname &&
      this.state.plname &&
      this.state.dob &&
      getAge(this.state.dob) > 0 &&
      this.state.paddress
    ) {
      this.setState({ currentStep: this.state.type === "COVID" ? 5 : 6 });
    } else {
      this.setState({
        alert: (
          <SweetAlert
            warning
            title="Uh-Oh!"
            onConfirm={() => this.setState({ alert: null })}
            closeOnClickOutside={true}
          >
            {t("required")}
          </SweetAlert>
        ),
      });
    }
  }

  renderPatientInfo() {
    const { type } = this.state;
    return (
      <Card className="w-100">
        <CardBody className="text-center">
          <Row>
            <Col lg="6">
              <Typography variant="overline">
                {t("patient.form.fname")} *
              </Typography>
              <FormGroup className="w-100 d-flex flex-row">
                <Input
                  placeholder={t("patient.form.fname")}
                  type="text"
                  className="formControlFix"
                  name="pfname"
                  id="pfname"
                  value={this.state.pfname}
                  onChange={(e) => this.setState({ pfname: e.target.value })}
                />
              </FormGroup>

              <Typography variant="overline">
                {t("patient.form.mname")} *
              </Typography>
              <FormGroup className="w-100 d-flex flex-row">
                <Input
                  placeholder={t("patient.form.mname")}
                  type="text"
                  className="formControlFix"
                  name="pfname2"
                  id="pfname2"
                  value={this.state.pfname2}
                  onChange={(e) => this.setState({ pfname2: e.target.value })}
                />
              </FormGroup>

              <Typography variant="overline">
                {t("patient.form.lname1")} *
              </Typography>
              <FormGroup className="w-100 d-flex flex-row">
                <Input
                  placeholder={t("patient.form.lname1")}
                  type="text"
                  className="formControlFix"
                  name="plname"
                  id="plname"
                  value={this.state.plname}
                  onChange={(e) => this.setState({ plname: e.target.value })}
                />
              </FormGroup>
            </Col>
            <Col lg="6">
              {/*
              <Typography variant="overline">
                {t("patient.form.lname2")}
              </Typography>
              <FormGroup className="w-100 d-flex flex-row">
                <Input
                  placeholder={t("patient.form.lname2")}
                  type="text"
                  className="formControlFix"
                  name="plname2"
                  id="plname2"
                  value={this.state.plname2}
                  onChange={(e) => this.setState({ plname2: e.target.value })}
                />
              </FormGroup> */}

              <Typography variant="overline">
                {t("patient.form.dob")} *
              </Typography>
              <FormGroup
                className="w-100 d-flex flex-row"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignSelf: "center",
                }}
              >
                <DatePicker
                  onChange={(date) => this.setState({ dob: date })}
                  minDate={dayjs().subtract(120, "years").toDate()}
                  maxDate={dayjs().subtract(1, "years").toDate()}
                  value={this.state.dob} //dumb question, para hacerse pruebas/vacunar
                />
                {/* <Input
                  placeholder="MM/DD/YYYY"
                  type="tel"
                  maskChar=" "
                  mask="99/99/9999"
                  className="formControlFix"
                  name="dob"
                  id="dob"
                  value={this.state.dob}
                  onChange={(e) => this.setState({ dob: e.target.value })}
                  tag={InputMask}
                /> */}
              </FormGroup>

              <Typography variant="overline">
                {t("patient.form.address")}*
              </Typography>
              <FormGroup className="w-100 d-flex flex-row">
                <Input
                  placeholder={t("patient.form.address")}
                  type="textarea"
                  className="formControlFix"
                  name="paddress"
                  id="paddress"
                  value={this.state.paddress}
                  onChange={(e) => this.setState({ paddress: e.target.value })}
                />
              </FormGroup>
            </Col>

            <Col lg="2">
              <Button
                color="primary"
                disabled={this.state.clickOnPay}
                style={
                  this.state.clickOnPay
                    ? { cursor: "default" }
                    : { cursor: "pointer" }
                }
                onClick={() => {
                  this.state.type === "COVID"
                    ? this.validatePatientInfo()
                    : this._submitOrder();
                }}
              >
                {type === "COVID" ? t("button.next") : t("button.pay")}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }

  renderCovidQuestions() {
    const { vaccinated } = this.state;
    const testTypes = [
      { value: "PCR", label: "PCR (molecular)" },
      { value: "Antígeno", label: t("covid.labels.test.antigen") },
      { value: "Serológica", label: t("covid.labels.test.serology") },
      { value: "IgG Spike Protein", label: "IgG Spike Protein" },
      { value: "ID-NOW", label: "COVID-19 ID-NOW RNA" },
    ];
    const reasonTypes = [
      { value: "trabajo", label: t("covid.labels.reason.work") },
      { value: "viaje", label: t("covid.labels.reason.trip") },
      { value: "cita medica", label: t("covid.labels.reason.med") },
      // { value: "cernimiento", label: t("covid.labels.reason.cer") },
      { value: "otro", label: t("covid.labels.reason.other") },
    ];
    return (
      <Card className="w-100">
        <CardBody>
          <Row>
            <Col lg="12">
              <Typography variant="overline">
                {t("covid.questions.q1")}
              </Typography>
            </Col>
            <Col lg="12">
              <Checkbox
                onChange={(e) => this.setState({ symptom1: e.target.checked })}
                value={this.state.symptom1}
              />
              {t("covid.labels.l1")}
            </Col>
            <Col lg="12">
              <Checkbox
                onChange={(e) => this.setState({ symptom2: e.target.checked })}
                value={this.state.symptom2}
              />
              {t("covid.labels.l2")}
            </Col>
            <Col lg="12">
              <Checkbox
                onChange={(e) => this.setState({ symptom3: e.target.checked })}
                value={this.state.symptom3}
              />
              {t("covid.labels.l3")}
            </Col>
            <Col lg="12">
              <Checkbox
                onChange={(e) => this.setState({ symptom4: e.target.checked })}
                value={this.state.symptom4}
              />
              {t("covid.labels.l4")}
            </Col>
            <Col lg="12">
              <Checkbox
                onChange={(e) => this.setState({ symptom5: e.target.checked })}
                value={this.state.symptom5}
              />
              {t("covid.labels.l5")}
            </Col>
            <Col lg="12">
              <Checkbox
                onChange={(e) => this.setState({ symptom6: e.target.checked })}
                value={this.state.symptom6}
              />
              {t("covid.labels.l6")}
            </Col>
            <Col lg="12">
              <Checkbox
                onChange={(e) => this.setState({ symptom7: e.target.checked })}
                value={this.state.symptom7}
              />
              {t("covid.labels.l7")}
            </Col>
            <Col lg="12">
              <Checkbox
                onChange={(e) => this.setState({ symptom8: e.target.checked })}
                value={this.state.symptom8}
              />
              {t("covid.labels.l8")}
            </Col>
            <Col lg="12">
              <Checkbox
                onChange={(e) => this.setState({ symptom9: e.target.checked })}
                value={this.state.symptom9}
              />
              {t("covid.labels.l9")}
            </Col>
            <Col lg="12">
              <Checkbox
                onChange={(e) => this.setState({ symptom10: e.target.checked })}
                value={this.state.symptom10}
              />
              {t("covid.labels.l10")}
            </Col>

            <Col lg="12">
              <Typography variant="overline">
                {t("covid.questions.q2")} *
              </Typography>
              <RadioGroup
                aria-label="exposed"
                name="radio-buttons-group"
                onChange={(e) => {
                  const value = e.target.value;
                  const stateValue = {
                    exposed:
                      value === "has-covid"
                        ? "has-covid"
                        : parseBool(e.target.value),
                  };
                  return this.setState(stateValue);
                }}
              >
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label={t("button.yes")}
                />
                <FormControlLabel
                  value="has-covid"
                  control={<Radio />}
                  label={t("button.have-c19")}
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label={t("button.no")}
                />
              </RadioGroup>
              {typeof this.state.exposed === "boolean" &&
                this.state.exposed && <p>{t("covid.exposedMessage")}</p>}
            </Col>

            <Col lg="12">
              <Typography variant="overline">
                {t("covid.questions.q3")} *
              </Typography>
              <RadioGroup
                aria-label="vaccinated"
                name="radio-buttons-group"
                onChange={(e) =>
                  this.setState({ vaccinated: parseBool(e.target.value) })
                }
              >
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label={t("button.yes")}
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label={t("button.no")}
                />
              </RadioGroup>
            </Col>

            {vaccinated && (
              <Col lg="12">
                <Typography variant="overline">
                  {t("covid.questions.q3a")}
                </Typography>
                <RadioGroup
                  aria-label="vaccine"
                  name="radio-buttons-group"
                  onChange={(e) => this.setState({ vaccine: e.target.value })}
                >
                  <FormControlLabel
                    value="PFIZER"
                    control={<Radio />}
                    label="Pfizer / BioNTech"
                  />
                  <FormControlLabel
                    value="MODERNA"
                    control={<Radio />}
                    label="Moderna"
                  />
                  <FormControlLabel
                    value="JJ"
                    control={<Radio />}
                    label="J&J/Janssen"
                  />
                </RadioGroup>
              </Col>
            )}

            <Typography variant="overline">
              {t("covid.questions.q4")} *
            </Typography>
            <FormGroup className="w-100 d-flex flex-row">
              <Select
                className="w-100"
                options={testTypes}
                onChange={(e) => this.setState({ testType: e.value })}
              />
            </FormGroup>

            <Typography variant="overline">
              {t("covid.questions.q5")} *
            </Typography>
            <FormGroup className="w-100 d-flex flex-row">
              <Select
                className="w-100"
                options={reasonTypes}
                onChange={(e) => this.setState({ reason: e.value })}
              />
            </FormGroup>

            {/* <Typography variant="overline">
              {t("covid.questions.q5")} *
            </Typography>
            <FormGroup className="w-100 d-flex flex-row">
              <Input
                placeholder={t("covid.place.reason")}
                type="text"
                className="formControlFix"
                name="reason"
                id="reason"
                value={this.state.reason}
                onChange={(e) => this.setState({ reason: e.target.value })}
              />
            </FormGroup> */}
            {/* <Typography variant="overline">
              {t("covid.questions.q6")} *
            </Typography>
            <FormGroup className="w-100 d-flex flex-row">
              <Input
                placeholder={t("covid.place.plan")}
                type="text"
                className="formControlFix"
                name="plan"
                id="plan"
                value={this.state.plan}
                onChange={(e) => this.setState({ plan: e.target.value })}
              />
            </FormGroup> */}
            {/* <Typography variant="overline">
              {t("covid.questions.q7")}
            </Typography>
            <FormGroup className="w-100 d-flex flex-row">
              <Input
                placeholder={t("covid.place.lab")}
                type="text"
                className="formControlFix"
                name="lab"
                id="lab"
                value={this.state.lab}
                onChange={(e) => this.setState({ lab: e.target.value })}
              />
            </FormGroup> */}
            <Col lg="2">
              <Button
                color="primary"
                disabled={this.state.clickOnPay}
                style={
                  this.state.clickOnPay
                    ? { cursor: "default" }
                    : { cursor: "pointer" }
                }
                onClick={
                  () =>
                    this._submitOrderCovid() /*this.validateCovidQuestions()*/
                }
              >
                {t("button.pay")}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  }

  _submitOrderCovid = async () => {
    this.setState({ clickOnPay: true });

    const orderDocURL = await this.uploadFile();

    if (orderDocURL) {
      let { submitOrder } = this.props;
      const {
        name,
        email,
        phone,
        pfname,
        pfname2,
        plname,
        plname2,
        dob,
        paddress,
        exposed,
        vaccinated,
        vaccine,
        testType,
        reason,
        plan,
        lab,
        type,
      } = this.state;

      const {
        symptom1,
        symptom2,
        symptom3,
        symptom4,
        symptom5,
        symptom6,
        symptom7,
        symptom8,
        symptom9,
        symptom10,
      } = this.state;

      let symptomsList = [
        symptom1,
        symptom2,
        symptom3,
        symptom4,
        symptom5,
        symptom6,
        symptom7,
        symptom8,
        symptom9,
        symptom10,
      ];

      let variables = {
        name,
        email,
        phone,
        pfname,
        pfname2,
        plname,
        plname2,
        dob: dayjs(dob).toISOString(),
        paddress,
        symptoms: JSON.stringify(symptomsList),
        exposed,
        vaccinated,
        vaccine,
        testType,
        reason,
        plan,
        lab,
        type,
        orderDoc: orderDocURL,
      };

      if (exposed !== null && vaccinated !== null && testType && reason) {
        let mutationResponse = await submitOrder({ variables });

        if (mutationResponse.data) {
          // send to payment link
          this.props.history.push(
            `/pay/${mutationResponse.data.createOrder.id}`
          );
        }
      } else {
        this.setState({
          alert: (
            <SweetAlert
              warning
              title="Uh-Oh!"
              onConfirm={() => this.setState({ alert: null })}
              closeOnClickOutside={true}
            >
              {t("required")}
            </SweetAlert>
          ),
          clickOnPay: false,
        });
      }
    } else {
      this.setState({ clickOnPay: false });

      console.error("Could not process PDF");
    }
  };

  _submitOrder = async () => {
    this.setState({ clickOnPay: true });

    const orderDocURL = await this.uploadFile();

    if (orderDocURL) {
      let { submitOrder } = this.props;
      const {
        name,
        email,
        phone,
        pfname,
        pfname2,
        plname,
        plname2,
        dob,
        paddress,
        type,
      } = this.state;

      let variables = {
        name,
        email,
        phone,
        pfname,
        pfname2,
        plname,
        plname2,
        dob: dayjs(dob).toISOString(),
        paddress,
        type,
        orderDoc: orderDocURL,
      };

      if (
        this.state.pfname &&
        this.state.plname &&
        this.state.dob &&
        getAge(this.state.dob) > 0 &&
        this.state.paddress
      ) {
        let mutationResponse = await submitOrder({ variables });

        if (mutationResponse.data) {
          // disable pay button

          // send to payment link
          this.props.history.push(
            `/pay/${mutationResponse.data.createOrder.id}`
          );
        }
      } else {
        this.setState({
          alert: (
            <SweetAlert
              warning
              title="Uh-Oh!"
              onConfirm={() => this.setState({ alert: null })}
              closeOnClickOutside={true}
            >
              {t("required")}
            </SweetAlert>
          ),
          clickOnPay: false,
        });
      }
    } else {
      this.setState({ clickOnPay: false });
      console.error("Could not process PDF");
    }
  };

  handleSetLanguage() {
    const lang = localStorage.getItem("locale");
    let key = lang === "en" ? "es" : "en";

    localStorage.setItem("locale", key);
    setLanguage(key);
  }

  async uploadFile() {
    const config = {
      bucketName: process.env.REACT_APP_S3_BUCKET,
      region: process.env.REACT_APP_S3_REGION,
      accessKeyId: process.env.REACT_APP_ACCESS_KEY,
      secretAccessKey: process.env.REACT_APP_SECRET_KEY,
      dirName: process.env.REACT_APP_BUCKET_DIR,
    };

    const blob = await pdf(
      <PDFGen
        patientInfo={{
          pfname: this.state.pfname,
          pfname2: this.state.pfname2,
          plname: this.state.plname,
          plname2: this.state.plname2,
          paddress: this.state.paddress,
          dob: this.state.dob,
        }}
        hasCovid={this.state.exposed === "has-covid" ? true : false}
        orderDetails={{ type: this.state.type, testType: this.state.testType }}
        symptomsList={[
          this.state.symptom1,
          this.state.symptom2,
          this.state.symptom3,
          this.state.symptom4,
          this.state.symptom5,
          this.state.symptom6,
          this.state.symptom7,
          this.state.symptom8,
          this.state.symptom9,
          this.state.symptom10,
        ]}
      />
    ).toBlob();
    const file = new File([blob], `order-${v4()}.pdf`, {
      type: "application/pdf",
    });
    let url;
    if (file) {
      await S3FileUpload.uploadFile(file, config)
        .then((data) => {
          url = data.location;
        })
        .catch((err) => console.error(err));
      return url;
    } else {
      alert("No file to upload!");
      return null;
    }
  }

  render() {
    const { currentStep, type } = this.state;

    return (
      <div className="app">
        {this.state.alert}
        {/* <PDFViewer style={{ height: "100vh" }}>
          <PDFGen
            patientInfo={{
              pfname: this.state.pfname,
              pfname2: this.state.pfname2,
              plname: this.state.plname,
              plname2: this.state.plname2,
              paddress: this.state.paddress,
              dob: this.state.dob,
            }}
            hasCovid={this.state.exposed === "has-covid" ? true : false}
            orderDetails={{
              type: this.state.type,
              testType: this.state.testType,
            }}
            symptomsList={[
              this.state.symptom1,
              this.state.symptom2,
              this.state.symptom3,
              this.state.symptom4,
              this.state.symptom5,
              this.state.symptom6,
              this.state.symptom7,
              this.state.symptom8,
              this.state.symptom9,
              this.state.symptom10,
            ]}
          />
        </PDFViewer> */}
        <Container className="login-container">
          <Row className="justify-content-center">
            <Col lg="8">
              <div style={{ position: "sticky", top: 0 }}>
                <Button
                  color="primary"
                  onClick={() => this.handleSetLanguage()}
                >
                  {localStorage.getItem("locale") === "en"
                    ? "Español"
                    : "English"}
                </Button>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: window.innerWidth > 600 ? "row" : "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    // alignItems: "center",
                    objectFit: "cover",
                    width: "75%",
                    height: "15%",
                  }}
                >
                  <img
                    src={MedCert_Logo}
                    alt="tuordermedica.com logo"
                    style={{ width: "70%", height: "70%" }}
                  />
                </div>
                <div style={{ width: "70%", marginTop: "3%" }}>
                  <h4>About Us</h4>
                  <p>
                    En Tu Orden Médica proveemos servicio para Puerto Rico de
                    órdenes médicas en línea sin filas ni demoras. Un servicio
                    seguro con médicos puertorriqueños. Protegemos tu
                    privacidad. No compartimos tu información a terceros
                  </p>
                  <p>Servicio al Cliente Info@tuordenmedica.com</p>
                  <p>Página de Instagram @tuordenmedica</p>
                </div>
              </div>
              {/* ORDER TYPE */}
              <Accordion
                expanded={currentStep === 1}
                onChange={() => this.setState({ currentStep: 1 })}
              >
                <AccordionSummary
                  expandIcon={<Icon>expand_more</Icon>}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography color="textPrimary">
                    {currentStep > 1 && <Icon>check_circle</Icon>}{" "}
                    {t("pricing.title")} {type}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>{this.renderOrders()}</AccordionDetails>
              </Accordion>

              {/* USER INFO */}
              <Accordion
                expanded={currentStep === 2}
                onChange={() => this.setState({ currentStep: 2 })}
                disabled={currentStep <= 1}
              >
                <AccordionSummary
                  expandIcon={<Icon>expand_more</Icon>}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                >
                  <Typography color="textPrimary">
                    {currentStep > 2 && <Icon>check_circle</Icon>}{" "}
                    {t("info.title")}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>{this.renderUserInfo()}</AccordionDetails>
              </Accordion>

              {/* CONFIDENTIAL */}
              <Accordion
                expanded={currentStep === 3}
                onChange={() => this.setState({ currentStep: 3 })}
                disabled={currentStep <= 2}
              >
                <AccordionSummary
                  expandIcon={<Icon>expand_more</Icon>}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                >
                  <Typography color="textPrimary">
                    {currentStep > 3 && <Icon>check_circle</Icon>}{" "}
                    {t("coal.title")}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>{this.renderConfidential()}</AccordionDetails>
              </Accordion>

              {/* PATIENT INFO */}
              <Accordion
                expanded={currentStep === 4}
                onChange={() => this.setState({ currentStep: 4 })}
                disabled={currentStep <= 3}
              >
                <AccordionSummary
                  expandIcon={<Icon>expand_more</Icon>}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                >
                  <Typography color="textPrimary">
                    {currentStep > 4 && <Icon>check_circle</Icon>}{" "}
                    {t("patient.title")}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>{this.renderPatientInfo()}</AccordionDetails>
              </Accordion>

              {/* COVID INFO */}
              {type === "COVID" && (
                <Accordion
                  expanded={currentStep === 5}
                  onChange={() => this.setState({ currentStep: 5 })}
                  disabled={currentStep <= 4}
                >
                  <AccordionSummary
                    expandIcon={<Icon>expand_more</Icon>}
                    aria-controls="panel3bh-content"
                    id="panel3bh-header"
                  >
                    <Typography color="textPrimary">
                      {t("covid.title")}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {this.renderCovidQuestions()}
                  </AccordionDetails>
                </Accordion>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default compose(graphql(SubmitOrder, { name: "submitOrder" }))(
  withRouter(translate(Order))
);
